/**
 * Hidden Creation ID List
 *
 * Creations on this list will be hidden from the marketplace and user pages.
 */

const HIDDEN_CREATION_IDS = [
  478,
  14,
  15,
  17,
  18,
  19,
  20,
  23,
  24,
  248, // by user request 2021/11/23
  144, // 2021/12/10
  280, // 2021/12/10
  612, // 2021/12/10
  637, // 2021/12/10
  370, // 2022/05/20 ref: https://discord.com/channels/871910935843975168/872100998146056193/976718992217624617
  491, // 2022/05/20
  2369, // 2023/04/12 testing tweet/email
  2370, // 2023/04/12 testing tweet/email
];

export default HIDDEN_CREATION_IDS;
